function forEachNode (nodes, func) {
  Array.slice.call([], nodes).forEach(func)
}

export function bindClickEvent (element, selector, eventCallback, {preventDefault} = {}) {
  forEachNode(element.querySelectorAll(selector), node => {
    node.addEventListener('click', (e) => {
      if (preventDefault) {
        e.preventDefault()
      }

      eventCallback({node: node, e: e})
    })
  })
}

export function bindClickEventWithPreventDefault (element, selector, eventCallback) {
  bindClickEvent(element, selector, eventCallback, {preventDefault: true})
}

export function bindHoverEvent (element, selector, eventCallbackEnter, eventCallbackLeave, {preventDefault} = {}) {
  forEachNode(element.querySelectorAll(selector), node => {
    node.addEventListener('mouseenter', (e) => {
      eventCallbackEnter({node: node, e: e})
    })

    node.addEventListener('mouseleave', (e) => {
      eventCallbackLeave({node: node, e: e})
    })
  })
}



// WEBPACK FOOTER //
// ./src/shared/eventBinding.js